import {API_SERVERLESS, getFetch} from '~commonApi';

export function apiCertifiedCopiesContactInfo() {
    return getFetch(`${API_SERVERLESS}/common/v3/contactInfo`, true);
}
